import { UseFieldArrayRemove } from 'react-hook-form';

import { Widget } from '@kanda-libs/ks-component-ts';
import { Button, Text } from '@kanda-libs/ks-design-library';

import { CLASS_NAMES, PROPS } from './constants';
import useSecondaryEmploymentFields from './useSecondaryEmploymentFields';

import Employed from '../components/Employed';
import SelfEmployed from '../components/SelfEmployed';

export interface SecondaryEmploymentFieldsProps {
  index: number;
  arrayName: string;
  remove: UseFieldArrayRemove;
}

const SecondaryEmploymentFields: React.FunctionComponent<SecondaryEmploymentFieldsProps> =
  function ({ index, arrayName, remove }) {
    const { employmentStatus } = useSecondaryEmploymentFields(index, arrayName);
    return (
      <>
        <div className="w-full border-b border-neutral-300 mx-auto mb-4" />
        <div className={CLASS_NAMES.container}>
          <div className={CLASS_NAMES.header}>
            <Text
              className={CLASS_NAMES.title}
              text={`Secondary Employment ${index === 0 ? '' : index + 1}`}
            />
            <Button.Icon
              id="employment-details-remove"
              onClick={() => remove(index)}
              icon="remove"
              variant="custom"
              size="32-20"
              className="-mt-1.5"
              iconProps={{ stroke: 'red-200' }}
            />
          </div>
          <div className="flex flex-row gap-x-3 md:gap-x-4">
            <Widget.CreditAdditionalEmploymentDetailsEmploymentStatusArraySelect
              {...PROPS.employmentStatus}
              index={index}
              options={[
                { name: 'Employed', value: 'employed' },
                { name: 'Self Employed', value: 'self_employed' },
              ]}
            />
            <Widget.CreditAdditionalEmploymentDetailsGrossAnnualIncomeAmountArrayInput
              {...PROPS.grossAnnualIncome}
              index={index}
              name="gross_annual_income.amount"
            />
          </div>
          {employmentStatus === 'employed' && (
            <Employed type="secondary" index={index} arrayName={arrayName} />
          )}
          {employmentStatus === 'self_employed' && (
            <SelfEmployed
              type="secondary"
              index={index}
              arrayName={arrayName}
            />
          )}
        </div>
      </>
    );
  };

export default SecondaryEmploymentFields;
